import { render, staticRenderFns } from "./DragContainer.vue?vue&type=template&id=316df28c&scoped=true&"
import script from "./DragContainer.vue?vue&type=script&lang=js&"
export * from "./DragContainer.vue?vue&type=script&lang=js&"
import style0 from "./DragContainer.vue?vue&type=style&index=0&id=316df28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316df28c",
  null
  
)

export default component.exports